import { chakra, Box, Heading, Image } from "@chakra-ui/react";
import React from "react";
import { Layout } from "../Layout";
import { useAuth } from "../contexts/AuthContext";
import { collection } from "@firebase/firestore";
import { projectFirestoreDB } from "../../firebase/config";
import useFirestore from "../../hooks/useFirestore";

export default function ProfilePage() {
  const { currentUser } = useAuth();
  const collectionRef = collection(
    projectFirestoreDB,
    "users",
    currentUser ? currentUser.uid : "asd", // otherwise the page will fail the load as it cannot find the uid because the currentUser is null for a little while at refresh
    "memes"
  );
  const { docs } = useFirestore(collectionRef);

  return (
    <Layout>
      <Heading>Profile page</Heading>
      {/* <Container maxW="container.lg" overflowX="auto" py={4}>
        <chakra.pre p={4}>
          {currentUser && <pre> {JSON.stringify(currentUser, null, 2)}</pre>}
        </chakra.pre>
      </Container> */}
      <Heading size="lg">Your memes</Heading>
      <chakra.pre p={4}>
        <div className="img-grid">
          {docs &&
            docs.map((doc) => (
              <Box
                display="inline-block"
                float="left"
                clear="left"
                maxW="md"
                //mx="auto"
                py="5"
                //borderWidth="1px"
                //borderRadius="lg"
                overflow="hidden"
              >
                <Image
                  src={doc.url}
                  alt="uploaded picture"
                  width="100%"
                ></Image>
                <Box p="4" borderWidth="1px" display="flex">
                  {/* Ur pic */}
                </Box>
              </Box>
            ))}
        </div>
      </chakra.pre>
    </Layout>
  );
}
